var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlobLogoNyttigMat = function SvgBlobLogoNyttigMat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 202 67"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 142,
    height: 66,
    x: 60,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4DA7B9",
    fillRule: "evenodd",
    d: "M115.695 60.615c-35.346 5.904-51.496 1.809-54.655-13.23C57.156 28.9 73.349.593 100.877.593s29.235 2.1 62.568.991 50.396 44.522 27.61 60.465c-17.044 9.897-40.014-7.337-75.36-1.433",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B7E6D0",
    fillRule: "evenodd",
    d: "M115.695 60.615c-35.346 5.904-51.496 1.809-54.655-13.23C57.156 28.9 73.349.593 100.877.593s29.235 2.1 62.568.991 50.396 44.522 27.61 60.465c-17.044 9.897-40.014-7.337-75.36-1.433",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#61B783",
    d: "M202.74 18.345c12.011 8.847 3.043-.59 3.043 25.36C124.166 83.219 51.599 62.283 51.599 54.141c0 0-18.805-30.772 12.511-39.334 12.223-3.342 41.87 4.863 68.564 3.538 28.502-1.414 52.549-4.718 70.066 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CB585",
    fillOpacity: 0.8,
    d: "M186.5-1.847c8.5 4.847 30 44.653 30 51.5-2.5 34-161.041 13.25-161.041 6.347 0-6.904-25.46-10 18.041-31.5C84.068 19.277 101 15 120 7.5c22.5-8.882 58-14.194 66.5-9.347"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#E2EFDF",
    fillRule: "evenodd",
    d: "M72.475 36.366c-.57 16.311-19.4 30.297-35.662 29.73C20.552 65.529.261 57.304.832 40.994 1.402 24.665 25.058 4.165 41.32 4.732c16.668.582 31.724 15.324 31.154 31.634",
    clipRule: "evenodd",
    style: {
      mixBlendMode: "multiply"
    }
  }));
};
export default SvgBlobLogoNyttigMat;